<template>
  <div class="container">
    <div class="submit">
      <el-button type="primary" @click="updateNotice" v-if="mode == 'edit'"
        >修改资讯</el-button
      >
      <el-button type="primary" @click="addNotice" v-else>发布资讯</el-button>
    </div>
    <el-form ref="form" :model="form" label-width="80px">
      <el-row>
        <el-col :span="4">
          <el-form-item label="主题" required>
            <el-select v-model="form.ilk" placeholder="请选择">
              <el-option
                v-for="item in ilks"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select> </el-form-item
        ></el-col>
         <el-col :span="4">
          <el-form-item label="类型" required>
            <el-select v-model="form.type" placeholder="请选择">
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select> </el-form-item
        ></el-col>
        <el-col :span="4">
          <el-form-item label="角色" required>
            <el-select v-model="form.role" placeholder="请选择">
              <el-option
                v-for="item in roles"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select> </el-form-item
        ></el-col>
         <el-col :span="4">
          <el-form-item label="key" required>
             <el-input
              v-model="form.task_key"
              placeholder="任务key"
            ></el-input
          ></el-form-item
        ></el-col>
      </el-row>
      <el-form-item label="资讯标题" required>
        <el-row>
          <el-col :span="24">
            <el-input
              v-model="form.name"
              placeholder="填写资讯的标题"
            ></el-input
          ></el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="资讯摘要">
        <el-row>
          <el-col :span="24">
            <el-input
              type="form.descr"
              placeholder="填写资讯的摘要或子标题"
              maxlength="50"
              show-word-limit
              v-model="form.digest"
            ></el-input
          ></el-col>
        </el-row>
      </el-form-item>
    


         <el-form-item label="资讯摘要">
          

          <el-row>
            <el-col :span="6">
            <el-form-item label="类型">
            <el-select v-model="reward.type" placeholder="请选择">
              <el-option
                v-for="item in rewardList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select> </el-form-item
        ></el-col>
          <el-col :span="6">
            <el-form-item label="数量">
            <el-input
              v-model="reward.count"
              placeholder="填写资讯的标题"
            ></el-input
          ></el-form-item
        ></el-col>
        </el-row>
      </el-form-item>





    </el-form>
  </div>
</template>
<script>
import { ObjectChangedValue } from "@/js/utils.js";
export default {
  data() {
    return {
      isClear: false,
      wangEditorDetail: "",
      temp: {},
      form: {},
      reward:{},
      manager: JSON.parse(localStorage.getItem("managerInfo")),
      mode: "add",
      id: "",
      ilks: [
        {
          value: "newCoach",
          label: "教练新人福利",
        }
      ],
      roles: [
        {
          value: "coach",
          label: "教练",
        }
      ],
      typeList:[
        {
          value: "demand",
          label: "信息发布",
        }
      ],
      rewardList:[
        {
          value: "t_store",
          label: "发转店",
        }
      ],
    };
  },
  mounted() {
    //设置富文本框默认显示内容
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.mode = "edit";
      this.getInfo();
    } else {
      this.wangEditorDetail = "";
      this.mode = "add";
      // this.form.type = 'notice'
    }
  },

  methods: {
    getInfo() {
      this.$axios({
        url: "/user/tTask/findById",
        params: { id: this.id },
      }).then((res) => {
        this.wangEditorDetail = res.data.data.content;
        this.temp = Object.assign({}, res.data.data);
        this.form = res.data.data;
      });
    },

    updateNotice() {
      this.form.content = this.wangEditorDetail;
      const data = ObjectChangedValue(this.temp, this.form);
      if (Object.keys(data).length == 0) {
        this.$message("没有修改数据，无需更新");
        return;
      }
      if (this.check()) {
        data.id = this.id;
        this.$axios.post("/user/tTask/update", data).then(() => {
          this.$message("修改成功");
          this.$router.back();
        });
      }
    },
    getImgUrl(file) {
      this.form.index_img = file;
    },
    addNotice() {
     
      if (this.check()) {
        let data = {
         ...this.form,
         rewards:[this.reward]
        };
        this.$axios.post("/user/tTask/insert", data).then(() => {
          this.$message("添加成功");
          this.$router.back();
        });
      }
    },
    check() {
      
      return true;
    },
  },
};
</script>
<style scoped>
.container {
  position: relative;
}
.submit {
  position: absolute;
  right: 50px;
  top: 30px;
  z-index: 9999;
}
.wang {
  height: 500px;
}
</style>